export const toSnake = (s: string) => {
  return s
    .split(/(?=[A-Z])/)
    .join("_")
    .toLowerCase();
};
